import { DateInput } from 'react-admin';
import { useWatch } from 'react-hook-form';

const DateRangeInput = () => {
	const date_range = useWatch({ name: 'date_range' });
	return date_range === 'custom' ?
		<>
			<DateInput source="start_date" fullWidth={false} />
			<span>to</span>
			<DateInput source="end_date" fullWidth={false} />
		</>
		: null;

}

export default DateRangeInput;